import { cn } from '@/lib/utils';
import { getIconComponent } from '@/lib/admin/icons';
import { Database } from 'lucide-react';

interface SchemaItem {
  id: string;
  title: string;
}

interface Category {
  id: string;
  name: string;
  icon?: string;
  schemas: SchemaItem[];
}

interface DataStandardsSidebarProps {
  categories: Category[];
  activeSchemaId: string;
  onSchemaSelect: (schemaId: string) => void;
  isMobile?: boolean;
}

export function DataStandardsSidebar({ categories, activeSchemaId, onSchemaSelect, isMobile = false }: DataStandardsSidebarProps) {
  return (
    <aside className={cn("w-64 shrink-0", isMobile && "w-full")}>
      <div className={cn(
        isMobile 
          ? "max-h-[calc(100vh-8rem)] overflow-y-auto" 
          : "sticky top-20 max-h-[calc(100vh-6rem)] overflow-y-auto scrollbar-thin scrollbar-thumb-muted scrollbar-track-transparent"
      )}>
        <div className="flex items-center gap-2 mb-4">
          <Database className="h-5 w-5 text-primary" />
          <h2 className="font-semibold text-sm uppercase tracking-wide text-muted-foreground">Data Standards</h2>
        </div>
        
        <nav className="space-y-6 pb-8">
          {categories.map((category) => {
            const IconComponent = getIconComponent(category.icon || null);
            return (
              <div key={category.id}>
                <div className="flex items-center gap-2 mb-2">
                  <IconComponent className="h-4 w-4" />
                  <h3 className="font-medium text-sm">{category.name}</h3>
                </div>
                <ul className="space-y-1 ml-6">
                  {category.schemas.map((schema) => (
                    <li key={schema.id}>
                      <button
                        onClick={() => onSchemaSelect(schema.id)}
                        className={cn(
                          "w-full text-left px-3 py-2 md:py-1.5 text-sm rounded-md transition-colors",
                          activeSchemaId === schema.id
                            ? "bg-primary/10 text-primary font-medium"
                            : "text-muted-foreground hover:text-foreground hover:bg-muted"
                        )}
                      >
                        {schema.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
